

      <template>
        <div class="kugou-content" :style="{background:luck_back_color}">
          <!-- banner图 -->
          <img :src="luck_top_img" alt class="bg-banner" />
          <!-- 滚动号码 -->
          <div class="kugou-scroll">
            <ul class="bg-scroll">
              <img src="../../assets/images/lucky/name.png" alt class="notice-img" />
              <li v-for="(item, i) in list" :key="i" ref="rollLi" :class="{ 'anim' : animate && i == 0 }">
                <span class="lkq-name">{{ item.content }}</span>
              </li>
            </ul>
          </div>
            <div class="kugou-scroll" style="position: absolute;z-index:9999;margin: 0 auto;text-align: center;width: 100%;">
                <ul class="bg-scroll">
                    <li  ref="rollLi" >
                        <router-link :to="'/mylucky'" class="lkq-name">点击查看我的抽奖记录</router-link>
                    </li>
                </ul>
            </div>
          <!-- 抽奖弹窗 -->
          <div class="turntable" :style="{ backgroundImage: 'url(' + luck_middle_img + ')' }">
            <!-- 转动背景 -->
            <img :src="luck_move" alt :class="['run-item-' + current]" />
              <img :src="item.img" v-for="(item, i) in awards" :key="i" :class="['lucky'+i]" />
            <!-- 抽奖按钮 -->
            <img
                @click="handleStart"
                :src="luck_btn"
                alt
                class="start-btn-big"
            />
          </div>
        </div>
      </template>
      <script>

        import { Toast } from 'vant';
        import {getLuckList, getLuck, getUser} from "@api/user";
        import { openShareAll, wxShowLocation } from "@libs/wechat";
        import {isWeixin} from "@utils/index";
        import {getShare} from "@api/public";


        export default {
          name: "index",
          data() {
            return {
              isWeixin: isWeixin(),

              luck_top_img:'',
              luck_middle_img:'',
              luck_move:'',
              luck_back_color:'',
              luck_btn:'',

              animate: false,
              initSpeed: 200,  // 初始速度
              speed: null,  // 变化速度
              loading:false,
              loaded:false,
              diff: 20,  // 速度变化的值，值越大，变化地越快
              award: {},  // 抽中的奖品
              awards: [],
              time: 0,  // 记录开始抽奖的时间
              current: 0,  // 当前转动的位置
              isRuningLucky: false,  // 是否正在抽奖
              getLuckyMsg:'请稍等',
              getLucky:false,
              list: []
            };
          },
          created() {
          },
          mounted() {
            this.getLuckList();
            this.setOpenShare();
          },
          methods: {
            getLuckList: function() {
              let that = this;
              if (that.loading == true || that.loaded == true) return;
              that.loading = true;
              getLuckList().then(
                  res => {
                    that.loading = false;
                    that.awards = res.data.lucky_list;
                    that.list = res.data.luckList;
                    that.getLucky = res.data.getLucky;
                    that.getLuckyMsg = res.data.getLuckyMsg;


                    that.luck_top_img = res.data.luck_top_img;
                    that.luck_middle_img = res.data.luck_middle_img;
                    that.luck_move = res.data.luck_move;
                    that.luck_back_color = res.data.luck_back_color;
                    that.luck_btn = res.data.luck_btn;

                    if(!that.getLucky){
                      that.$dialog.message(res.data.getLuckyMsg);
                    }
                  },
                  error => {
                    that.$dialog.message(error.msg);
                  }
              );
            },
            // 抽奖
            handleStart() {
              if (this.isRuningLucky) {
                return Toast("正在抽奖中...");
              }
              if(!this.getLucky){
                return Toast(this.getLuckyMsg);
              }
              if (isNaN(Number(this.initSpeed))) {
                return false;
              }
              this.speed = this.initSpeed;
              // 开始抽奖
              this.isRuningLucky = true;
              this.time = Date.now();
              this.drawAward();
              //Toast("开始抽奖");
            },
            drawAward() {
              let that = this;
              getLuck().then(
                  res => {
                    that.award = {
                      id: res.data.id
                    };


                  },
                  error => {
                    that.$dialog.message(error.msg);
                  }
              );
              that.move();

            },
            move() {
              let that = this;
              let timer = setTimeout(() => {
                this.current++;
                if (this.current > 7) {
                  this.current = 0;
                }
                // 若抽中的奖品id存在，则开始减速转动
                if (this.award.id && (Date.now() - this.time) / 1000 > 2) {
                  console.log("奖品出来了");
                  this.speed += this.diff; // 转动减速

                  // 若转动时间超过4秒，并且奖品id等于小格子的奖品id，则停下来
                  if ((Date.now() - this.time) / 1000 > 4 && this.award.id == this.awards[this.current].id) {
                    clearTimeout(timer);

                    setTimeout(() => {
                      this.isRuningLucky = false;
                      // 这里写停下来要执行的操作（弹出奖品框）
                      this.getLucky = false;
                      this.getLuckyMsg = "今日次数已用完";
                      if(this.awards[this.current].type==3){
                        that.$dialog.confirm({
                          title:"提示",
                          mes: this.awards[this.current].name,
                          opts: [
                            {
                              txt: "好的",
                              color: false,
                              callback: () => {
                                location.href = "/";
                              }
                            }
                          ]
                        });
                      }else if(this.awards[this.current].type==1){
                        that.$dialog.confirm({
                          title:"恭喜您抽中",
                          mes: this.awards[this.current].name,
                          opts: [
                            {
                              txt: "查看明细",
                              color: false,
                              callback: () => {
                                location.href = "/user/bill/point_money";
                              }
                            }
                          ]
                        });
                      }else if(this.awards[this.current].type==2){
                        that.$dialog.confirm({
                          title:"恭喜您抽中",
                          mes: this.awards[this.current].name,
                          opts: [
                            {
                              txt: "立即领取",
                              color: false,
                              callback: () => {
                                location.href = "/detail/"+this.awards[this.current].num;
                              }
                            }
                          ]
                        });
                      }

                    }, 400);
                    return;
                  }

                  // 若抽中的奖品不存在，则加速转动
                } else {
                  if (this.speed >= 50) {
                    this.speed -= this.diff; // 转动加速
                  }
                }

                this.move();
              }, this.speed);
            },
            // 中奖名单滚动
            scroll() {
              this.animate = true;
              let timer = setTimeout(() => {
                this.list.push(this.list[0]);
                this.list.shift();
                this.animate = false;
              }, 500);
            },

          setOpenShare() {
            if (isWeixin()) {


                getUser().then(res => {
                  var href = location.href;

                  href =
                      href.indexOf("?") === -1
                          ? href + "?spread=" + res.data.uid
                          : href + "&spread=" + res.data.uid;
                  var nickname = res.data.nickname;


                  getShare().then(res => {
                    var data = res.data.data;
                    var configAppMessage = {
                      desc: '['+nickname+'邀请] 幸运大抽奖',
                      title: data.title,
                      link: href,
                      imgUrl: data.img
                    };
                    openShareAll(configAppMessage);
                  });
                })



            }
          }

          }
        };
      </script>
      <style lang="less" scoped>

        .kugou-content {

          width: 100%;
          overflow: hidden;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          padding-top: 2.9rem;
          // 顶部图片
          .bg-banner {
            position: absolute;
            top: 0;
            right: 0;
            width: 7.5rem;
          }
          // 滚动号码
          .kugou-scroll {
            .bg-scroll {
              position: relative;
              background: url("../../assets/images/lucky/phone.png") center top no-repeat;
              background-size: 100%;
              width: 100%;
              height: 0.74rem;
              line-height: 0.74rem;
              font-size: 0.35rem;
              overflow: hidden;
              text-align: center;
              letter-spacing: 0.03rem;
            }
            .lkq-name {
              margin: 0 auto;
              color: #fff;
              font-size: 0.28rem;
            }
            .anim {
              transition: all 0.5s linear;
              margin-top: -0.74rem;
            }
          }
          // 抽奖
          .turntable {
            position: relative;
            background-repeat:no-repeat;
            background-size: 8.5rem;
            background-position: -1.06rem -0.9rem;
            height: 8.2rem;
            padding: 1.55rem 0.83rem 1.15rem;
            .present-content {
              width: 75%;
              position: absolute;
              top: 1.68rem;
              left: 0.96rem;
              z-index: 100;
            }
            .start-btn-big {
              width: 1.8rem;
              position: absolute;
              top: 3.55rem;
              left: 2.88rem;
              z-index: 999;
            }
            .lucky0,.lucky1,.lucky2,.lucky3,.lucky4,.lucky5,.lucky6,.lucky7{
            width: 1.8rem;
            height:1.8rem;
            position: absolute;
            z-index: 1;
          }
            .lucky0{
              top: 1.68rem;
              left: 0.94rem;
            }
            .lucky1{
              top: 1.68rem;
              left: 2.87rem;
            }
            .lucky2{
              top: 1.68rem;
              left: 4.8rem;
            }
            .lucky3{
              top: 3.57rem;
              left: 4.8rem;
            }
            .lucky4{
              top: 5.45rem;
              left: 4.8rem;
            }



            .lucky5{
              top: 5.45rem;
              left: 2.87rem;

            }
            .lucky6{
              top: 5.45rem;
              left: 0.94rem;
            }
            .lucky7{
              top: 3.57rem;
              left: 0.94rem;
            }



            .run-item-0 {
              width: 2.03rem;
            }
            .run-item-1 {
              width: 2.03rem;
              display: block;
              margin: 0 0 0 1.93rem;
            }
            .run-item-2 {
              width: 2.03rem;
              display: block;
              margin: 0 0 0 3.85rem;
            }
            .run-item-3 {
              width: 2.03rem;
              display: block;
              margin: 1.9rem 0 0 3.85rem;
            }
            .run-item-4 {
              width: 2.03rem;
              display: block;
              margin: 3.8rem 0 0 3.85rem;
            }
            .run-item-5 {
              width: 2.03rem;
              display: block;
              margin: 3.8rem 0 0 1.925rem;
            }
            .run-item-6 {
              width: 2.03rem;
              display: block;
              margin: 3.8rem 0 0 0;
            }
            .run-item-7 {
              width: 2.03rem;
              display: block;
              margin: 1.9rem 0 0 0;
            }
          }

        }

        @keyframes btn-animation {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(0.85);
          }
        }

        .notice-img {
          position: absolute;
          top: 0.12rem;
          left: 0.55rem;
        }
      </style>
